
import axios from 'axios';
import { API_KEY, BASE_URL, getAxiosConfig } from '../../components/interface/Config';

const API_URL = `${BASE_URL}/resource/patientHealth`;

export const fetchAllergies = async (token: string,params: Record<string, any>) => {
    try {
       
        const response = await axios.get<{ data: { patient_healths: any[], pagination: { total: number } } }>(API_URL, {
            params,
            headers: getAxiosConfig().headers
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch allergies.');
    }
};


